<template>
  <div class="content content--with-tabs">
    <MyHeader :breadcrumbItems="[
        {
          name: pageName.name,
          path: this.$route.path
        },
      ]"/>

    <header class="content-header">
      <h1>{{pageName.name}}</h1>
      <button :class="['article-list-button', {active: showList}]" @click="showList = ! showList"><i class="icon-list"></i></button>
    </header>

    <!-- tabs for mobile -->
    <transition name="fade">
      <div class="article-list" v-if="showList">
        <template v-for="(year) in Object.values(years)">
          <div class="tab-title" :key="year.id">{{year.value}}</div>
          <div class="tabs-vertical" :key="`months-${year.id}`">
            <ul class="tabs-inner">
              <li v-for="(tab) in Object.values(year.months)" :key="tab.id" >
                <a :class="{'active': tab.month === active.month && tab.year === active.year}" @click="selectTab(tab)">
                    <span>{{tab.name}}
                      <span v-if="eventLive" class="tab-live"></span>
                    </span>
                  <i class="icon-arrow"></i>
                </a>
              </li>
            </ul>
          </div>
        </template>
      </div>
    </transition>

    <div class="container main-content--tabbed">
      <div class="row">
        <template v-if="Object.values(this.years).length">
          <div class="col-lg-3 d-none d-lg-block">
            <template v-for="(year) in Object.values(years)">
              <div class="tab-title" :key="year.id">{{year.value}}</div>
              <div class="tabs-vertical" :key="`months-${year.id}`">
                <ul class="tabs-inner">
                  <li v-for="(tab) in Object.values(year.months)" :key="tab.id" >
                    <a :class="{'active': tab.month === active.month && tab.year === active.year}" @click="selectTab(tab)">
                      <span>{{tab.name}}
                        <span v-if="eventLive" class="tab-live"></span>
                      </span>
                      <i class="icon-arrow"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </template>
          </div>
          <div class="col-lg-9">
            <div class="row boxes-row">
              <div class="col-lg-4" v-for="box in boxes" :key="box.idAgendaEntry">
                <BoxAgenda :box="box" />
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="col-lg-12">
            <div class="row" style="justify-content: center;">
              <div style="display:flex; justify-content: center; flex-direction: column;">
                <img src="../../assets/images/coming-soon-1.svg">
                <div>No upcoming events.</div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import BoxAgenda from '../../components/agenda/BoxAgenda'
import MyHeader from '../../components/general/Header'
import settingUser from "@/api/settingUser";
import moment from "moment/moment";
import settings from "@/settings";
export default {
  name: "Agenda",
  components: {MyHeader, BoxAgenda},
  data () {
    return {
      showList: false
    }
  },
  computed: {
    active() {
      if(Object.values(this.years).length) {
        if (this.$route.query.year && this.$route.query.month) return {
          year: Number( this.$route.query.year),
          month: Number( this.$route.query.month)
        }
        return Object.values(Object.values(this.years)[0].months)[0]
      }
      return null
    },
    years() {
      return this.$store.getters.agendaTabs
    },
    boxes() {
      return this.$store.getters.agendaBoxes(this.active)
    },
    eventLive() {
      return false;
    },
    pageName() {
      return this.$store.getters.menu().find((item) => {
        return item.routeName === 'Agenda'
      })
    },
    section() {
      return this.$store.getters.sectionByCode(settings.MODULES.AGENDA)
    },
  },
  mounted() {
    this.getAgenda()
    window._paq.push(['setDocumentTitle', this.pageName.name]);
    window._paq.push(['trackPageView']);
    this.updateNotificationDate();
  },
  methods: {
    updateNotificationDate() {
      settingUser.createSettingUser({
        idUser: this.$store.getters.user.idUser,
        idSettingCompany: this.section.idSettingCompany,
        valueDate: moment().format('YYYY-MM-DD HH:mm:ss'),
      }, () => {
        this.$store.dispatch('updateNotification', this.section.idSettingCompany)
        this.$store.dispatch('getUserInfo')
      })
    },
    getAgenda() {
      this.$store.dispatch('getAgenda')
    },
    selectTab(tab) {
      this.showList = false;
      let query = {
        year: tab.year,
        month: tab.month,
      }
      this.$router.push({query})
    }
  }
}
</script>
